import {CalculatorManager} from './CalculatorManager';

function App() {
  return (
    <CalculatorManager />
  );
}

export default App;
